import { cartAxiosInstance as network } from '../../axios';
import { Endpoints, SiteTypes } from '../../enums';
import { CartUserReplacementResponse } from '../../types';
import { endpointReplace } from '../../utils/endpointReplace';
import { getAuthenticationConfig } from '../../utils/getAuthenticationConfig';

export const postUserReplacement = async (userId: string) => {
  const path = endpointReplace({ ':siteType': SiteTypes.CART }, Endpoints.PostCartUserReplacement);
  const authentication = await getAuthenticationConfig();

  const response = await network.post<CartUserReplacementResponse>(
    path,
    {
      userId: userId,
      userSource: 'irw',
    },
    authentication,
  );

  return response.data;
};
